import { useRouteError } from '@spazious/dollhouse-router';
import { useStoreApi } from '@spazious/dollhouse-store';

import { MainLayout } from '../../layouts/index.js';
import { ErrorDialog } from '../ErrorDialog/index.js';

export const RootBoundary: React.FC = () => {
  const error = useRouteError();
  const store = useStoreApi();

  return (
    <MainLayout>
      <ErrorDialog
        closeButtonText="Restart"
        error={error as Error}
        message="Click on the restart button to discard your work and reload the application."
        open={true}
        onClose={(_, reason) => {
          if (reason === 'btnClose') {
            store.persist.clearStorage();
          }
          window.location.reload();
        }}
      />
    </MainLayout>
  );
};
